import React from "react";
import type { AIEvaluation } from "./ReviewResponseModel.types";

interface AIEvaluationPopupProps {
  evaluation: AIEvaluation;
  onClose: () => void;
}

const AIEvaluationPopup: React.FC<AIEvaluationPopupProps> = ({
  evaluation,
  onClose,
}) => {
  return (
    <div className="review-popup-overlay" onClick={onClose}
    onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          onClose();
        }
      }}
      role="button"
      tabIndex={0}>
      <div
        className="review-popup-container review-ai-evaluation-popup"
        onClick={(e) => e.stopPropagation()}
         onKeyDown={(e) => e.stopPropagation()}
        role="dialog"
      >
        <div className="review-popup-header">
          <h3>AI Evaluation</h3>
          <button className="review-popup-close-button" onClick={onClose}>
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M15 5L5 15M5 5l10 10" />
            </svg>
          </button>
        </div>

        <div className="review-popup-content">
          <div className="review-evaluation-status">
            <span className="review-status-label">Status:</span>
            <span
              className={`review-status-badge ${evaluation.status === "Satisfied" ? "satisfied" : "not-satisfied"}`}
            >
              {evaluation.status}
            </span>
          </div>

          <div className="review-evaluation-reason">
            <span className="review-reason-label">Reason:</span>
            <p className="review-reason-text">{evaluation.reason}</p>
          </div>

          <div className="review-evaluation-timestamp">
            <span className="review-timestamp-label">Evaluated at:</span>
            <span className="review-timestamp-text">
              {new Date(evaluation.timestamp).toLocaleString("en-US", {
                year: "numeric",
                month: "short",
                day: "numeric",
                hour: "numeric",
                minute: "2-digit",
                hour12: true,
              })}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AIEvaluationPopup;
